export const HkustMapInformation = {
  alignmentSetting: "mesh_alignment",
  venue: "HKUST",
  venueId: "4a87acdb-cfa6-4246-9651-32f935666d83",
  i18nVenue: "venue_hkust",
  venueName: "HKUST",
  venueName_zh: "HKUST",
  avatarIsFloating: true,
  floorAlignment: [
    {
      id: "02f16d3a-90dc-43ea-95ad-e5dbfe6c78fe",
      lcMapId: "02f16d3a-90dc-43ea-95ad-e5dbfe6c78fe",
      lcMapName: "CYT 1F",
      name: "CYT 1F",
      ordinal: 1,
      shortName: "1F",
      imageUrl:
        "https://gis-dev.locaite.com/assets/4a87acdb-cfa6-4246-9651-32f935666d83/map/1788758179256_43dd.jpg",
      pixInMeter: 13.711807363891664,
      size: { width: 1609, height: 1139 },
      angle: 90.2044362596755,
      scale: 72.92988785500394,
      center: { lat: 22.33480949454507, lng: 114.26358775885 },
      corners: {
        bl: { lat: 22.33533867142269, lng: 114.26318628396237 },
        br: { lat: 22.334283181683226, lng: 114.2631819105718 },
        tl: { lat: 22.33533580738524, lng: 114.26399360712819 },
        tr: { lat: 22.334280317667453, lng: 114.26398922762758 },
      },
      sizeInMeters: { width: 117.36612825116417, height: 83.03599932852673 },
    },
    {
      id: "0759eb00-d3db-41c3-85af-b692dec6c0b5",
      lcMapId: "0759eb00-d3db-41c3-85af-b692dec6c0b5",
      lcMapName: "LSK 5F",
      name: "LSK 5F",
      ordinal: 5,
      shortName: "5F",
      imageUrl:
        "https://gis-dev.locaite.com/assets/4a87acdb-cfa6-4246-9651-32f935666d83/map/1788759572566_c118.jpg",
      pixInMeter: 14.242094999465085,
      size: { width: 2044, height: 1226 },
      angle: 50.33352312050532,
      scale: 70.21447749701024,
      center: { lat: 22.33335111861227, lng: 114.26501640009946 },
      corners: {
        bl: { lat: 22.33360080422311, lng: 114.26424893236745 },
        br: { lat: 22.332607270001876, lng: 114.2651396150903 },
        tl: { lat: 22.334094967222665, lng: 114.26489318654225 },
        tr: { lat: 22.33310142948124, lng: 114.26578386783146 },
      },
      sizeInMeters: { width: 143.51821133370544, height: 86.0828410436525 },
    },
    {
      id: "2048ca45-7ef3-4417-b5b8-bbcdc4aa203a",
      lcMapId: "2048ca45-7ef3-4417-b5b8-bbcdc4aa203a",
      lcMapName: "1F",
      name: "1F",
      ordinal: 1,
      shortName: "1F",
      imageUrl:
        "https://gis-dev.locaite.com/assets/4a87acdb-cfa6-4246-9651-32f935666d83/map/1789555328948_326c.png",
      pixInMeter: 0.9963241610189489,
      bbox: [-33.54313, -153.16756, 38.55552, 23.54999],
      size: { width: 72, height: 176 },
      angle: 359.5,
      scale: 1003.6894006359543,
      center: { lat: 22.336714094161024, lng: 114.2638356195157 },
      corners: {
        bl: { lat: 22.335916966993544, lng: 114.26349181700812 },
        br: { lat: 22.33592263838153, lng: 114.26419440994152 },
        tl: { lat: 22.33750554995667, lng: 114.26347682905453 },
        tr: { lat: 22.337511221312344, lng: 114.26417942198748 },
      },
      sizeInMeters: { width: 72.2652252012414, height: 176.64933271495983 },
    },
    {
      id: "29b2c36e-7df8-49bd-9c71-81fbe950567d",
      lcMapId: "29b2c36e-7df8-49bd-9c71-81fbe950567d",
      lcMapName: "CYT G",
      name: "CYT G",
      ordinal: 0,
      shortName: "G",
      imageUrl:
        "https://gis-dev.locaite.com/assets/4a87acdb-cfa6-4246-9651-32f935666d83/map/1788758056735_bb03.jpg",
      pixInMeter: 13.98188748682369,
      size: { width: 1641, height: 1161 },
      angle: 90.21961778700975,
      scale: 71.5211446502177,
      center: { lat: 22.33480949454507, lng: 114.26358775885 },
      corners: {
        bl: { lat: 22.33533867142269, lng: 114.26318628396237 },
        br: { lat: 22.334283181683226, lng: 114.2631819105718 },
        tl: { lat: 22.33533580738524, lng: 114.26399360712819 },
        tr: { lat: 22.334280317667453, lng: 114.26398922762758 },
      },
      sizeInMeters: { width: 117.36612825116417, height: 83.03599932852673 },
    },
    {
      id: "346f8168-550d-4c73-ba98-2e0f319bbdad",
      lcMapId: "346f8168-550d-4c73-ba98-2e0f319bbdad",
      lcMapName: "GF",
      name: "GF",
      ordinal: 0,
      shortName: "GF",
      imageUrl:
        "https://gis-dev.locaite.com/assets/4a87acdb-cfa6-4246-9651-32f935666d83/map/1789555653248_5f0d.png",
      pixInMeter: 0.9946595914474524,
      bbox: [-135.65436, -21.13531, 34.325, 102.42612],
      size: { width: 169, height: 123 },
      angle: 0,
      scale: 1005.369081670462,
      center: { lat: 22.337538879057504, lng: 114.26342067550127 },
      corners: {
        bl: { lat: 22.33698282749126, lng: 114.26259468836687 },
        br: { lat: 22.33698282749126, lng: 114.26424666263563 },
        tl: { lat: 22.338094930623747, lng: 114.26259468836687 },
        tr: { lat: 22.338094930623747, lng: 114.26424666263563 },
      },
      sizeInMeters: { width: 169.90669724962598, height: 123.66039704500302 },
    },
    {
      id: "372c1e0b-a00b-4713-b1dd-12f3d656f3e8",
      lcMapId: "372c1e0b-a00b-4713-b1dd-12f3d656f3e8",
      lcMapName: "CYT outdoor",
      name: "CYT outdoor",
      ordinal: 0,
      shortName: "outdoor",
      imageUrl:
        "https://gis-dev.locaite.com/assets/4a87acdb-cfa6-4246-9651-32f935666d83/map/1789397941854_e35b.png",
      pixInMeter: 0.9990673125571065,
      bbox: [
        -58.63069534301758, -24.775001525878906, 84.58979797363281, 196.375,
      ],
      size: { width: 143, height: 221 },
      angle: 183.5,
      scale: 1000.9335581785738,
      center: { lat: 22.33428056727613, lng: 114.26355306977348 },
      corners: {
        bl: { lat: 22.335234096871684, lng: 114.264313237799 },
        br: { lat: 22.335312680584224, lng: 114.2629241986873 },
        tl: { lat: 22.333248454248263, lng: 114.26418193125232 },
        tr: { lat: 22.333327037400338, lng: 114.2627929118986 },
      },
      sizeInMeters: { width: 143.13349784492402, height: 221.2062851988529 },
    },
    {
      id: "382b0c83-fc08-478a-935a-05f2d23f45b1",
      lcMapId: "382b0c83-fc08-478a-935a-05f2d23f45b1",
      lcMapName: "2F",
      name: "2F",
      ordinal: 2,
      shortName: "2F",
      imageUrl:
        "https://gis-dev.locaite.com/assets/4a87acdb-cfa6-4246-9651-32f935666d83/map/1789551130916_21bb.png",
      pixInMeter: 0.9979458711737839,
      bbox: [-69.57499, -14.85, 100.79493, 130.425],
      size: { width: 170, height: 145 },
      angle: 135.5,
      scale: 1002.0583569164129,
      center: { lat: 22.335716506007717, lng: 114.26393519401358 },
      corners: {
        bl: { lat: 22.336719402493365, lng: 114.2640307749914 },
        br: { lat: 22.335645612924456, lng: 114.26284944724421 },
        tl: { lat: 22.335787396575604, lng: 114.26502093856766 },
        tr: { lat: 22.33471361203743, lng: 114.26383961649049 },
      },
      sizeInMeters: { width: 170.34980624557136, height: 145.29874145265208 },
    },
    {
      id: "4b6c0a05-ee98-4cca-af47-37e1b16a332c",
      lcMapId: "4b6c0a05-ee98-4cca-af47-37e1b16a332c",
      lcMapName: "3F",
      name: "3F",
      ordinal: 3,
      shortName: "3F",
      imageUrl:
        "https://gis-dev.locaite.com/assets/4a87acdb-cfa6-4246-9651-32f935666d83/map/1789553060167_11c7.png",
      pixInMeter: 0.997988153926999,
      bbox: [-37.12898, -12.84443, 48.325, 107.19678],
      size: { width: 85, height: 120 },
      angle: 24.4,
      scale: 1002.0159017613,
      center: { lat: 22.336167311928648, lng: 114.26392576747935 },
      corners: {
        bl: { lat: 22.33583313522709, lng: 114.26330722588557 },
        br: { lat: 22.335516711777462, lng: 114.26406135914385 },
        tl: { lat: 22.336817911466404, lng: 114.2637901766443 },
        tr: { lat: 22.33650148924363, lng: 114.26454430909337 },
      },
      sizeInMeters: { width: 85.17103615932506, height: 120.24197641697131 },
    },
    {
      id: "52b1c043-f4a0-408f-98d2-e5e24b968083",
      lcMapId: "52b1c043-f4a0-408f-98d2-e5e24b968083",
      lcMapName: "LG1",
      name: "LG1",
      ordinal: -1,
      shortName: "LG1",
      imageUrl:
        "https://gis-dev.locaite.com/assets/4a87acdb-cfa6-4246-9651-32f935666d83/map/1788752537186_4c05.jpg",
      pixInMeter: 13.860013861546703,
      size: { width: 6006, height: 3188 },
      angle: 89.93256920453153,
      scale: 72.15040034288907,
      center: { lat: 22.33700574711711, lng: 114.26367032197913 },
      corners: {
        bl: { lat: 22.338953069313487, lng: 114.26254965922078 },
        br: { lat: 22.335056006544303, lng: 114.26255462997688 },
        tl: { lat: 22.338955487689923, lng: 114.2647860452679 },
        tr: { lat: 22.335058453825667, lng: 114.26479098473749 },
      },
      sizeInMeters: { width: 433.33129101367945, height: 230.0158069436353 },
    },
    {
      id: "576f32e6-f3ac-4837-b28a-25f90fe910c2",
      lcMapId: "576f32e6-f3ac-4837-b28a-25f90fe910c2",
      lcMapName: "LG4",
      name: "LG4",
      ordinal: -4,
      shortName: "LG4",
      imageUrl:
        "https://gis-dev.locaite.com/assets/4a87acdb-cfa6-4246-9651-32f935666d83/map/1788753353514_e545.jpg",
      pixInMeter: 13.81215469751532,
      size: { width: 6006, height: 3188 },
      angle: 90.54526092555362,
      scale: 72.4,
      center: { lat: 22.33701414072378, lng: 114.2636595640663 },
      corners: {
        bl: { lat: 22.33897921341914, lng: 114.26255766340739 },
        br: { lat: 22.335068821639346, lng: 114.26251744542503 },
        tl: { lat: 22.338959445256048, lng: 114.26480169849094 },
        tr: { lat: 22.33504908258063, lng: 114.26476144934702 },
      },
      sizeInMeters: { width: 434.83279714516874, height: 230.81281803932018 },
    },
    {
      id: "57ca9200-e5cb-4b0e-92a4-da711ccbabb1",
      lcMapId: "57ca9200-e5cb-4b0e-92a4-da711ccbabb1",
      lcMapName: "LSK G",
      name: "LSK G",
      ordinal: 0,
      shortName: "G",
      imageUrl:
        "https://gis-dev.locaite.com/assets/4a87acdb-cfa6-4246-9651-32f935666d83/map/1788758615095_01d1.jpg",
      pixInMeter: 14.072196790191946,
      size: { width: 2044, height: 1226 },
      angle: 50.30791725486177,
      scale: 71.06219954949967,
      center: { lat: 22.333461777822485, lng: 114.26493371625855 },
      corners: {
        bl: { lat: 22.333714156819745, lng: 114.26415686000266 },
        br: { lat: 22.33270900011287, lng: 114.26505878269921 },
        tl: { lat: 22.3342145555321, lng: 114.2648086512794 },
        tr: { lat: 22.333209395218887, lng: 114.26571057251444 },
      },
      sizeInMeters: { width: 145.2509533836, height: 87.12214718484455 },
    },
    {
      id: "635ba158-5fd9-47fe-89d4-c26e3d216c58",
      lcMapId: "635ba158-5fd9-47fe-89d4-c26e3d216c58",
      lcMapName: "CYT 7F",
      name: "CYT 7F",
      ordinal: 7,
      shortName: "7F",
      imageUrl:
        "https://gis-dev.locaite.com/assets/4a87acdb-cfa6-4246-9651-32f935666d83/map/1788758378381_b095.jpg",
      pixInMeter: 13.711807363891664,
      size: { width: 1609, height: 1139 },
      angle: 90.2044362596755,
      scale: 72.92988785500394,
      center: { lat: 22.33480949454507, lng: 114.26358775885 },
      corners: {
        bl: { lat: 22.33533867142269, lng: 114.26318628396237 },
        br: { lat: 22.334283181683226, lng: 114.2631819105718 },
        tl: { lat: 22.33533580738524, lng: 114.26399360712819 },
        tr: { lat: 22.334280317667453, lng: 114.26398922762758 },
      },
      sizeInMeters: { width: 117.36612825116417, height: 83.03599932852673 },
    },
    {
      id: "6440ce15-d725-4f42-b47e-b5321cc1ea6e",
      lcMapId: "6440ce15-d725-4f42-b47e-b5321cc1ea6e",
      lcMapName: "LG3",
      name: "LG3",
      ordinal: -3,
      shortName: "LG3",
      imageUrl:
        "https://gis-dev.locaite.com/assets/4a87acdb-cfa6-4246-9651-32f935666d83/map/1788753051185_5b15.jpg",
      pixInMeter: 13.65187713451661,
      size: { width: 6006, height: 3188 },
      angle: 89.93256920453153,
      scale: 73.25,
      center: { lat: 22.33700125051529, lng: 114.26366546059921 },
      corners: {
        bl: { lat: 22.338978253555545, lng: 114.26252770246447 },
        br: { lat: 22.335021775887927, lng: 114.26253275264253 },
        tl: { lat: 22.338980710246112, lng: 114.26479818465407 },
        tr: { lat: 22.335024262371558, lng: 114.2648032025844 },
      },
      sizeInMeters: { width: 439.9378415765465, height: 233.52265632098917 },
    },
    {
      id: "65136560-22f8-4beb-9b0b-b282a4b39b61",
      lcMapId: "65136560-22f8-4beb-9b0b-b282a4b39b61",
      lcMapName: "LG7",
      name: "LG7",
      ordinal: -7,
      shortName: "LG7",
      imageUrl:
        "https://gis-dev.locaite.com/assets/4a87acdb-cfa6-4246-9651-32f935666d83/map/1788754164794_3f09.jpg",
      pixInMeter: 13.596119061833825,
      size: { width: 6006, height: 3188 },
      angle: 90.5,
      scale: 73.55040034288908,
      center: { lat: 22.336986611292442, lng: 114.26364899416535 },
      corners: {
        bl: { lat: 22.33898208959815, lng: 114.26252788037755 },
        br: { lat: 22.33500953475853, lng: 114.26249041630035 },
        tl: { lat: 22.338963672807974, lng: 114.2648075883152 },
        tr: { lat: 22.3349911480051, lng: 114.26477009205166 },
      },
      sizeInMeters: { width: 441.74204894527907, height: 234.48034616284636 },
    },
    {
      id: "65d01e4d-1c85-4a87-a7a4-2bcaaaee2bf4",
      lcMapId: "65d01e4d-1c85-4a87-a7a4-2bcaaaee2bf4",
      lcMapName: "LSK 4F",
      name: "LSK 4F",
      ordinal: 4,
      shortName: "4F",
      imageUrl:
        "https://gis-dev.locaite.com/assets/4a87acdb-cfa6-4246-9651-32f935666d83/map/1788759300171_0234.jpg",
      pixInMeter: 13.443905273797862,
      size: { width: 2001, height: 1201 },
      angle: 51.40962197560457,
      scale: 74.38323976236651,
      center: { lat: 22.333349491249255, lng: 114.26502897593826 },
      corners: {
        bl: { lat: 22.333622052236404, lng: 114.26423822026402 },
        br: { lat: 22.332575807630832, lng: 114.26514085176984 },
        tl: { lat: 22.334123174867678, lng: 114.26491710195619 },
        tr: { lat: 22.33307692650292, lng: 114.26581973161252 },
      },
      sizeInMeters: { width: 148.8406797894321, height: 89.33416113148301 },
    },
    {
      id: "6fda081c-86c7-4fda-a236-4e4925a6ff04",
      lcMapId: "6fda081c-86c7-4fda-a236-4e4925a6ff04",
      lcMapName: "Campas Map",
      name: "Campas Map",
      ordinal: 0,
      shortName: "Campas",
      imageUrl:
        "https://gis-dev.locaite.com/assets/4a87acdb-cfa6-4246-9651-32f935666d83/map/1788760315721_0ce2.jpg",
      pixInMeter: 3.03573271869469,
      size: { width: 4961, height: 3508 },
      angle: 359.2273773902409,
      scale: 329.40676412585,
      center: { lat: 22.33659062224175, lng: 114.26387741547897 },
      corners: {
        bl: { lat: 22.331295620137894, lng: 114.2560102280564 },
        br: { lat: 22.331494295251794, lng: 114.27189708281321 },
        tl: { lat: 22.341686934423613, lng: 114.25585774814473 },
        tr: { lat: 22.341885624345608, lng: 114.27174578656923 },
      },
      sizeInMeters: { width: 1634.2018384776375, height: 1155.5694510481205 },
    },
    {
      id: "7fc1956c-15d0-4d2e-bd25-1427eb83e9b1",
      lcMapId: "7fc1956c-15d0-4d2e-bd25-1427eb83e9b1",
      lcMapName: "7F",
      name: "7F",
      ordinal: 7,
      shortName: "7F",
      imageUrl:
        "https://gis-dev.locaite.com/assets/4a87acdb-cfa6-4246-9651-32f935666d83/map/1788757298627_9ecf.jpg",
      pixInMeter: 13.688303061709211,
      size: { width: 4680, height: 3311 },
      angle: 89.98096611188512,
      scale: 73.05573724849867,
      center: { lat: 22.336625245159205, lng: 114.26346117424556 },
      corners: {
        bl: { lat: 22.338162257533465, lng: 114.2622847227523 },
        br: { lat: 22.33508750163862, lng: 114.26228586595455 },
        tl: { lat: 22.338162988679787, lng: 114.26463653439231 },
        tr: { lat: 22.335088232768605, lng: 114.26463762573883 },
      },
      sizeInMeters: { width: 341.8977486680945, height: 241.88535164121916 },
    },
    {
      id: "82db292d-76b6-4270-92d7-74d301edc94e",
      lcMapId: "82db292d-76b6-4270-92d7-74d301edc94e",
      lcMapName: "LSK 3F",
      name: "LSK 3F",
      ordinal: 3,
      shortName: "3F",
      imageUrl:
        "https://gis-dev.locaite.com/assets/4a87acdb-cfa6-4246-9651-32f935666d83/map/1788759163787_81c4.jpg",
      pixInMeter: 13.768058124902026,
      size: { width: 2044, height: 1226 },
      angle: 49.49836828744179,
      scale: 72.63197475079888,
      center: { lat: 22.333345563810422, lng: 114.26500974981208 },
      corners: {
        bl: { lat: 22.33359311511705, lng: 114.2642118724269 },
        br: { lat: 22.332577904502934, lng: 114.26514931837836 },
        tl: { lat: 22.33411322311791, lng: 114.26487018254178 },
        tr: { lat: 22.33309800871791, lng: 114.26580762719726 },
      },
      sizeInMeters: { width: 148.45957080089292, height: 89.04668972572071 },
    },
    {
      id: "907061cb-1675-4000-9373-41281d3c96ab",
      lcMapId: "907061cb-1675-4000-9373-41281d3c96ab",
      lcMapName: "LSK 2F",
      name: "LSK 2F",
      ordinal: 2,
      shortName: "2F",
      imageUrl:
        "https://gis-dev.locaite.com/assets/4a87acdb-cfa6-4246-9651-32f935666d83/map/1788758977533_50e2.jpg",
      pixInMeter: 13.919123095956358,
      size: { width: 2044, height: 1226 },
      angle: 49.737787313479615,
      scale: 71.84369630626071,
      center: { lat: 22.333326618375573, lng: 114.26499444707918 },
      corners: {
        bl: { lat: 22.33357453135972, lng: 114.2642063422811 },
        br: { lat: 22.33256676354187, lng: 114.2651290694387 },
        tl: { lat: 22.334086473209275, lng: 114.26485982605458 },
        tr: { lat: 22.333078701692298, lng: 114.26578255187727 },
      },
      sizeInMeters: { width: 146.8483313134826, height: 88.08026134285693 },
    },
    {
      id: "9a9e22e8-6739-42b0-8986-78c0c859674a",
      lcMapId: "9a9e22e8-6739-42b0-8986-78c0c859674a",
      lcMapName: "6F",
      name: "6F",
      ordinal: 6,
      shortName: "6F",
      imageUrl:
        "https://gis-dev.locaite.com/assets/4a87acdb-cfa6-4246-9651-32f935666d83/map/1788757225906_2b7c.jpg",
      pixInMeter: 10.28123210483655,
      size: { width: 3510, height: 2484 },
      angle: 90.13688965721333,
      scale: 97.26468456721769,
      center: { lat: 22.336639927618627, lng: 114.26349061196727 },
      corners: {
        bl: { lat: 22.33817766019653, lng: 114.26232003393389 },
        br: { lat: 22.335107400285043, lng: 114.26231210781422 },
        tl: { lat: 22.338172454837597, lng: 114.26466911612032 },
        tr: { lat: 22.335102195040726, lng: 114.26466113828151 },
      },
      sizeInMeters: { width: 341.39877050945756, height: 241.60528374673737 },
    },
    {
      id: "a6219c6b-d268-46de-8ec9-d46e795cbfc2",
      lcMapId: "a6219c6b-d268-46de-8ec9-d46e795cbfc2",
      lcMapName: "CYT 4F",
      name: "CYT 4F",
      ordinal: 4,
      shortName: "4F",
      imageUrl:
        "https://gis-dev.locaite.com/assets/4a87acdb-cfa6-4246-9651-32f935666d83/map/1788758281850_953c.jpg",
      pixInMeter: 14.26568125128201,
      size: { width: 1674, height: 1185 },
      angle: 90.20473384995645,
      scale: 70.09834336876276,
      center: { lat: 22.33480949454507, lng: 114.26358775885 },
      corners: {
        bl: { lat: 22.33533867142269, lng: 114.26318628396237 },
        br: { lat: 22.334283181683226, lng: 114.2631819105718 },
        tl: { lat: 22.33533580738524, lng: 114.26399360712819 },
        tr: { lat: 22.334280317667453, lng: 114.26398922762758 },
      },
      sizeInMeters: { width: 117.36612825116417, height: 83.03599932852673 },
    },
    {
      id: "a7cef609-9914-4152-a165-6dc552476e63",
      lcMapId: "a7cef609-9914-4152-a165-6dc552476e63",
      lcMapName: "CYT UG",
      name: "CYT UG",
      ordinal: -1,
      shortName: "UG",
      imageUrl:
        "https://gis-dev.locaite.com/assets/4a87acdb-cfa6-4246-9651-32f935666d83/map/1788757816023_063d.jpg",
      pixInMeter: 13.98188748682369,
      size: { width: 1641, height: 1161 },
      angle: 90.21961778700975,
      scale: 71.5211446502177,
      center: { lat: 22.33480949454507, lng: 114.26358775885 },
      corners: {
        bl: { lat: 22.33533867142269, lng: 114.26318628396237 },
        br: { lat: 22.334283181683226, lng: 114.2631819105718 },
        tl: { lat: 22.33533580738524, lng: 114.26399360712819 },
        tr: { lat: 22.334280317667453, lng: 114.26398922762758 },
      },
      sizeInMeters: { width: 117.36612825116417, height: 83.03599932852673 },
    },
    {
      id: "a82f3739-1b26-4e38-9455-a3075e4e55ac",
      lcMapId: "a82f3739-1b26-4e38-9455-a3075e4e55ac",
      lcMapName: "Room2539",
      name: "Room2539",
      ordinal: 2,
      shortName: "Rm2539",
      imageUrl:
        "https://gis-dev.locaite.com/assets/4a87acdb-cfa6-4246-9651-32f935666d83/map/1789554090518_98e1.png",
      pixInMeter: 0.8415370784995382,
      size: { width: 3, height: 4 },
      angle: 183,
      scale: 1188.3017706062506,
      center: { lat: 22.336221408654282, lng: 114.26411642415707 },
      corners: {
        bl: { lat: 22.336241913699222, lng: 114.26413493999132 },
        br: { lat: 22.336243591585887, lng: 114.26410032697743 },
        tl: { lat: 22.336199225722805, lng: 114.26413252133148 },
        tr: { lat: 22.336200903609214, lng: 114.26409790832815 },
      },
      sizeInMeters: { width: 3.5649053091482594, height: 4.753207067797053 },
    },
    {
      id: "aca2686d-d34a-45bc-8735-a1cdf98fd925",
      lcMapId: "aca2686d-d34a-45bc-8735-a1cdf98fd925",
      lcMapName: "CYT 5F",
      name: "CYT 5F",
      ordinal: 5,
      shortName: "5F",
      imageUrl:
        "https://gis-dev.locaite.com/assets/4a87acdb-cfa6-4246-9651-32f935666d83/map/1788758322031_3954.jpg",
      pixInMeter: 14.26568125128201,
      size: { width: 1674, height: 1185 },
      angle: 90.20473384995645,
      scale: 70.09834336876276,
      center: { lat: 22.33480949454507, lng: 114.26358775885 },
      corners: {
        bl: { lat: 22.33533867142269, lng: 114.26318628396237 },
        br: { lat: 22.334283181683226, lng: 114.2631819105718 },
        tl: { lat: 22.33533580738524, lng: 114.26399360712819 },
        tr: { lat: 22.334280317667453, lng: 114.26398922762758 },
      },
      sizeInMeters: { width: 117.36612825116417, height: 83.03599932852673 },
    },
    {
      id: "bb94db39-9f6a-4b2b-becb-3982f456ef65",
      lcMapId: "bb94db39-9f6a-4b2b-becb-3982f456ef65",
      lcMapName: "CYT 6F",
      name: "CYT 6F",
      ordinal: 6,
      shortName: "6F",
      imageUrl:
        "https://gis-dev.locaite.com/assets/4a87acdb-cfa6-4246-9651-32f935666d83/map/1788758346982_2ed4.jpg",
      pixInMeter: 14.26568125128201,
      size: { width: 1674, height: 1185 },
      angle: 90.20473384995645,
      scale: 70.09834336876276,
      center: { lat: 22.33480949454507, lng: 114.26358775885 },
      corners: {
        bl: { lat: 22.33533867142269, lng: 114.26318628396237 },
        br: { lat: 22.334283181683226, lng: 114.2631819105718 },
        tl: { lat: 22.33533580738524, lng: 114.26399360712819 },
        tr: { lat: 22.334280317667453, lng: 114.26398922762758 },
      },
      sizeInMeters: { width: 117.36612825116417, height: 83.03599932852673 },
    },
    {
      id: "bbbf6b6c-232a-41a7-9a64-4be0ce01c9cd",
      lcMapId: "bbbf6b6c-232a-41a7-9a64-4be0ce01c9cd",
      lcMapName: "LG5",
      name: "LG5",
      ordinal: -5,
      shortName: "LG5",
      imageUrl:
        "https://gis-dev.locaite.com/assets/4a87acdb-cfa6-4246-9651-32f935666d83/map/1788753900708_8175.jpg",
      pixInMeter: 13.614703881573869,
      size: { width: 6006, height: 3188 },
      angle: 90,
      scale: 73.45,
      center: { lat: 22.3370090240996, lng: 114.26365486091709 },
      corners: {
        bl: { lat: 22.338992665662264, lng: 114.26251651932353 },
        br: { lat: 22.33502538253695, lng: 114.26251653551662 },
        tl: { lat: 22.33899265068424, lng: 114.26479320251065 },
        tr: { lat: 22.335025397514983, lng: 114.26479318631766 },
      },
      sizeInMeters: { width: 441.13903446545703, height: 234.16026537781912 },
    },
    {
      id: "be73849d-994a-4e4f-8f4c-961bcfdcb45e",
      lcMapId: "be73849d-994a-4e4f-8f4c-961bcfdcb45e",
      lcMapName: "LSK 7F",
      name: "LSK 7F",
      ordinal: 7,
      shortName: "7F",
      imageUrl:
        "https://gis-dev.locaite.com/assets/4a87acdb-cfa6-4246-9651-32f935666d83/map/1788760170031_f9e4.jpg",
      pixInMeter: 13.564073192581423,
      size: { width: 2044, height: 1226 },
      angle: 51.1820812648322,
      scale: 73.72425969445663,
      center: { lat: 22.333344300733913, lng: 114.2650422914474 },
      corners: {
        bl: { lat: 22.33361747717391, lng: 114.26424074645145 },
        br: { lat: 22.332561583088808, lng: 114.2651591468805 },
        tl: { lat: 22.33412701837902, lng: 114.26492543784265 },
        tr: { lat: 22.333071120436323, lng: 114.26584383644334 },
      },
      sizeInMeters: { width: 150.69219776152465, height: 90.38582898897225 },
    },
    {
      id: "c9766a04-e0dd-4ce8-a312-9c14bba51228",
      lcMapId: "c9766a04-e0dd-4ce8-a312-9c14bba51228",
      lcMapName: "LSK 1F",
      name: "LSK 1F",
      ordinal: 1,
      shortName: "1F",
      imageUrl:
        "https://gis-dev.locaite.com/assets/4a87acdb-cfa6-4246-9651-32f935666d83/map/1788758808107_2715.jpg",
      pixInMeter: 13.976616907628943,
      size: { width: 2044, height: 1226 },
      angle: 49.86188496813057,
      scale: 71.54816220708537,
      center: { lat: 22.333327891054548, lng: 114.2649980800102 },
      corners: {
        bl: { lat: 22.333576356087306, lng: 114.26421379708852 },
        br: { lat: 22.332570895115754, lng: 114.26513037637251 },
        tl: { lat: 22.33408488699334, lng: 114.26486578500621 },
        tr: { lat: 22.333079422355723, lng: 114.26578236293189 },
      },
      sizeInMeters: { width: 146.2442602164542, height: 87.71793689876883 },
    },
    {
      id: "ce647405-f860-4e27-a678-bb783dc610a7",
      lcMapId: "ce647405-f860-4e27-a678-bb783dc610a7",
      lcMapName: "CYT 2F",
      name: "CYT 2F",
      ordinal: 2,
      shortName: "2F",
      imageUrl:
        "https://gis-dev.locaite.com/assets/4a87acdb-cfa6-4246-9651-32f935666d83/map/1788758209989_5493.jpg",
      pixInMeter: 14.26568125128201,
      size: { width: 1674, height: 1185 },
      angle: 90.20473384995645,
      scale: 70.09834336876276,
      center: { lat: 22.33480949454507, lng: 114.26358775885 },
      corners: {
        bl: { lat: 22.33533867142269, lng: 114.26318628396237 },
        br: { lat: 22.334283181683226, lng: 114.2631819105718 },
        tl: { lat: 22.33533580738524, lng: 114.26399360712819 },
        tr: { lat: 22.334280317667453, lng: 114.26398922762758 },
      },
      sizeInMeters: { width: 117.36612825116417, height: 83.03599932852673 },
    },
    {
      id: "ecaf7407-0dd6-4602-8d39-0f5e8c50cd16",
      lcMapId: "ecaf7407-0dd6-4602-8d39-0f5e8c50cd16",
      lcMapName: "4F",
      name: "4F",
      ordinal: 4,
      shortName: "4F",
      imageUrl:
        "https://gis-dev.locaite.com/assets/4a87acdb-cfa6-4246-9651-32f935666d83/map/1788756767149_09a6.jpg",
      pixInMeter: 13.82667935009134,
      size: { width: 4680, height: 3311 },
      angle: 89.86516502907818,
      scale: 72.32459639839863,
      center: { lat: 22.336633180145768, lng: 114.26346189579506 },
      corners: {
        bl: { lat: 22.338152629766846, lng: 114.26229389561374 },
        br: { lat: 22.335108654112513, lng: 114.2623016783607 },
        tl: { lat: 22.338157706179018, lng: 114.26462216405147 },
        tr: { lat: 22.335113730413653, lng: 114.26462989597638 },
      },
      sizeInMeters: { width: 338.4760636620858, height: 239.46458264057307 },
    },
    {
      id: "f75d121e-466f-4500-91a6-f3a99f6f4258",
      lcMapId: "f75d121e-466f-4500-91a6-f3a99f6f4258",
      lcMapName: "LSK 6F",
      name: "LSK 6F",
      ordinal: 6,
      shortName: "6F",
      imageUrl:
        "https://gis-dev.locaite.com/assets/4a87acdb-cfa6-4246-9651-32f935666d83/map/1788759764150_d7fb.jpg",
      pixInMeter: 13.256759383541553,
      size: { width: 2001, height: 1201 },
      angle: 50.80211658223176,
      scale: 75.43330860591372,
      center: { lat: 22.33338361901046, lng: 114.2650318919068 },
      corners: {
        bl: { lat: 22.333652147415076, lng: 114.26422684962412 },
        br: { lat: 22.332600170084817, lng: 114.2651543342683 },
        tl: { lat: 22.3341670679361, lng: 114.26490945126973 },
        tr: { lat: 22.33311508672196, lng: 114.26583693418947 },
      },
      sizeInMeters: { width: 150.94186611413593, height: 90.59529295173859 },
    },
    {
      id: "f8a4716b-abcb-4e22-9d0d-660c6451128d",
      lcMapId: "f8a4716b-abcb-4e22-9d0d-660c6451128d",
      lcMapName: "5F",
      name: "5F",
      ordinal: 5,
      shortName: "5F",
      imageUrl:
        "https://gis-dev.locaite.com/assets/4a87acdb-cfa6-4246-9651-32f935666d83/map/1788757131291_2700.jpg",
      pixInMeter: 13.798786776084112,
      size: { width: 4680, height: 3311 },
      angle: 89.84799629056855,
      scale: 72.47079245500547,
      center: { lat: 22.33663769538955, lng: 114.26348442533103 },
      corners: {
        bl: { lat: 22.338159891919783, lng: 114.26231357094059 },
        br: { lat: 22.335109765536473, lng: 114.26232235762475 },
        tl: { lat: 22.338165625242624, lng: 114.2646465440649 },
        tr: { lat: 22.335115498733693, lng: 114.26465527972147 },
      },
      sizeInMeters: { width: 339.16025197472334, height: 239.94863125260795 },
    },
  ],
  modelConfig: {
    folderPath: "venue/hkust/",
    defaultPosition: [12.5188, 1, 35.3602],
    defaultTarget: [17.5188, 1, 35.3602],
    defaultLcMapId: "346f8168-550d-4c73-ba98-2e0f319bbdad",
    topAltitude: 50,
    downSpeed: 200,
    scaleFactor: 1000,
    moveSpeed: 2,
    rotateSpeed: 20,
    splat: {
      mode: "floorLod",
    },
    floor: [
      {
        id: "02f16d3a-90dc-43ea-95ad-e5dbfe6c78fe",
        lcMapId: "02f16d3a-90dc-43ea-95ad-e5dbfe6c78fe",
        name: "CYT 1F",
        shortName: "1F",
        yAxis: 0,
        altitude: 0,
        defaultPosition: [0, 0, 0],
        defaultTarget: [0, 0, 0],
        displayLod: [],
        topViewModel: "",
        isNotReady: true,
      },
      {
        id: "0759eb00-d3db-41c3-85af-b692dec6c0b5",
        lcMapId: "0759eb00-d3db-41c3-85af-b692dec6c0b5",
        name: "LSK 5F",
        shortName: "5F",
        yAxis: 0,
        altitude: 0,
        defaultPosition: [0, 0, 0],
        defaultTarget: [0, 0, 0],
        displayLod: [],
        topViewModel: "",
        isNotReady: true,
      },
      {
        id: "2048ca45-7ef3-4417-b5b8-bbcdc4aa203a",
        lcMapId: "2048ca45-7ef3-4417-b5b8-bbcdc4aa203a",
        name: "1F",
        shortName: "1F",
        yAxis: 0,
        altitude: 1,
        defaultPosition: [2.7336, 1, -35.4832],
        defaultTarget: [2.7336, 1, -40.4832],
        topViewModel: "mesh_alignment/1f/top_view/1f_top_view_v1.glb",
        meshGround:
          "mesh_alignment/1f/mesh_ground/1f_mesh_ground_v1.glb",
        lod: "mesh_alignment/1f/splat/1f_v1_100_20_1_c512_x16_h0_st_3_3_0/lod-meta.json",
        displayLod: ["2048ca45-7ef3-4417-b5b8-bbcdc4aa203a"],
      },
      {
        id: "29b2c36e-7df8-49bd-9c71-81fbe950567d",
        lcMapId: "29b2c36e-7df8-49bd-9c71-81fbe950567d",
        name: "CYT G",
        shortName: "G",
        yAxis: 0,
        altitude: 0,
        defaultPosition: [0, 0, 0],
        defaultTarget: [0, 0, 0],
        displayLod: [],
        topViewModel: "",
        isNotReady: true,
      },
      {
        id: "346f8168-550d-4c73-ba98-2e0f319bbdad",
        lcMapId: "346f8168-550d-4c73-ba98-2e0f319bbdad",
        name: "GF",
        shortName: "GF",
        yAxis: 0,
        altitude: 1,
        defaultPosition: [12.5188, 1, 35.3602],
        defaultTarget: [17.5188, 1, 35.3602],
        topViewModel: "mesh_alignment/atrium/top_view/atrium_top_view_v2.glb",
        meshGround:
          "mesh_alignment/atrium/mesh_ground/atrium_mesh_ground_v3.glb",
        meshObstacle:
          "mesh_alignment/atrium/mesh_obstacle/atrium_mesh_obstacle_v1.glb",
        lod: "mesh_alignment/atrium/splat/atrium_splat_v1_100_20_1_c512_x16_h0_st_3_3_0/lod-meta.json",
        displayLod: ["346f8168-550d-4c73-ba98-2e0f319bbdad"],
      },
      {
        id: "372c1e0b-a00b-4713-b1dd-12f3d656f3e8",
        lcMapId: "372c1e0b-a00b-4713-b1dd-12f3d656f3e8",
        name: "CYT outdoor",
        shortName: "CYT",
        yAxis: 0,
        altitude: 1,
        defaultPosition: [3.5, 1, 71],
        defaultTarget: [3.5, 1, 71],
        topViewModel:
          "mesh_alignment/outdoor_Area_Near_CYT_Building/top_view/outdoor_Area_Near_CYT_Building_top_view_v1.glb",
        meshGround:
          "mesh_alignment/outdoor_Area_Near_CYT_Building/mesh_ground/outdoor_Area_Near_CYT_Building_mesh_ground_v1.glb",
        lod: "mesh_alignment/outdoor_Area_Near_CYT_Building/splat/outdoor_Area_Near_CYT_Building_v1_100_20_1_c512_x16_h0_st_3_3_0/lod-meta.json",
        displayLod: ["372c1e0b-a00b-4713-b1dd-12f3d656f3e8"],
      },
      {
        id: "382b0c83-fc08-478a-935a-05f2d23f45b1",
        lcMapId: "382b0c83-fc08-478a-935a-05f2d23f45b1",
        name: "2F",
        shortName: "2F",
        yAxis: 0,
        altitude: 1,
        defaultPosition: [-15, 1, 30],
        defaultTarget: [-17.5, 1, 32.5],
        topViewModel: "mesh_alignment/2f/top_view/2f_top_view_v1.glb",
        meshGround:
          "mesh_alignment/2f/mesh_ground/2f_mesh_ground_v1.glb",
        lod: "mesh_alignment/2f/splat/2f_v1_100_20_1_c512_x16_h0_st_3_3_0/lod-meta.json",
        displayLod: ["382b0c83-fc08-478a-935a-05f2d23f45b1"],
      },
      {
        id: "4b6c0a05-ee98-4cca-af47-37e1b16a332c",
        lcMapId: "4b6c0a05-ee98-4cca-af47-37e1b16a332c",
        name: "3F",
        shortName: "3F",
        yAxis: 0,
        altitude: 1,
        defaultPosition: [-14, 1, 54],
        defaultTarget: [-16.5, 1, 55],
        topViewModel: "mesh_alignment/3f/top_view/3f_top_view_v1.glb",
        meshGround:
          "mesh_alignment/3f/mesh_ground/3f_mesh_ground_v3.glb",
        meshObstacle:
          "mesh_alignment/3f/mesh_obstacle/3f_mesh_obstacle_v2.glb",
        lod: "mesh_alignment/3f/splat/3f_v1_100_20_1_c512_x16_h0_st_3_3_0/lod-meta.json",
        displayLod: ["4b6c0a05-ee98-4cca-af47-37e1b16a332c"],
      },
      {
        id: "52b1c043-f4a0-408f-98d2-e5e24b968083",
        lcMapId: "52b1c043-f4a0-408f-98d2-e5e24b968083",
        name: "LG1",
        shortName: "LG1",
        yAxis: 0,
        altitude: 0,
        defaultPosition: [0, 0, 0],
        defaultTarget: [0, 0, 0],
        displayLod: [],
        topViewModel: "",
        isNotReady: true,
      },
      {
        id: "576f32e6-f3ac-4837-b28a-25f90fe910c2",
        lcMapId: "576f32e6-f3ac-4837-b28a-25f90fe910c2",
        name: "LG4",
        shortName: "LG4",
        yAxis: 0,
        altitude: 0,
        defaultPosition: [0, 0, 0],
        defaultTarget: [0, 0, 0],
        displayLod: [],
        topViewModel: "",
        isNotReady: true,
      },
      {
        id: "57ca9200-e5cb-4b0e-92a4-da711ccbabb1",
        lcMapId: "57ca9200-e5cb-4b0e-92a4-da711ccbabb1",
        name: "LSK G",
        shortName: "G",
        yAxis: 0,
        altitude: 0,
        defaultPosition: [0, 0, 0],
        defaultTarget: [0, 0, 0],
        displayLod: [],
        topViewModel: "",
        isNotReady: true,
      },
      {
        id: "635ba158-5fd9-47fe-89d4-c26e3d216c58",
        lcMapId: "635ba158-5fd9-47fe-89d4-c26e3d216c58",
        name: "CYT 7F",
        shortName: "7F",
        yAxis: 0,
        altitude: 0,
        defaultPosition: [0, 0, 0],
        defaultTarget: [0, 0, 0],
        displayLod: [],
        topViewModel: "",
        isNotReady: true,
      },
      {
        id: "6440ce15-d725-4f42-b47e-b5321cc1ea6e",
        lcMapId: "6440ce15-d725-4f42-b47e-b5321cc1ea6e",
        name: "LG3",
        shortName: "LG3",
        yAxis: 0,
        altitude: 0,
        defaultPosition: [0, 0, 0],
        defaultTarget: [0, 0, 0],
        displayLod: [],
        topViewModel: "",
        isNotReady: true,
      },
      {
        id: "65136560-22f8-4beb-9b0b-b282a4b39b61",
        lcMapId: "65136560-22f8-4beb-9b0b-b282a4b39b61",
        name: "LG7",
        shortName: "LG7",
        yAxis: 0,
        altitude: 0,
        defaultPosition: [0, 0, 0],
        defaultTarget: [0, 0, 0],
        displayLod: [],
        topViewModel: "",
        isNotReady: true,
      },
      {
        id: "65d01e4d-1c85-4a87-a7a4-2bcaaaee2bf4",
        lcMapId: "65d01e4d-1c85-4a87-a7a4-2bcaaaee2bf4",
        name: "LSK 4F",
        shortName: "4F",
        yAxis: 0,
        altitude: 0,
        defaultPosition: [0, 0, 0],
        defaultTarget: [0, 0, 0],
        displayLod: [],
        topViewModel: "",
        isNotReady: true,
      },
      {
        id: "6fda081c-86c7-4fda-a236-4e4925a6ff04",
        lcMapId: "6fda081c-86c7-4fda-a236-4e4925a6ff04",
        name: "Campas Map",
        shortName: "Campas",
        yAxis: 0,
        altitude: 0,
        defaultPosition: [0, 0, 0],
        defaultTarget: [0, 0, 0],
        displayLod: [],
        topViewModel: "",
        isNotReady: true,
      },
      {
        id: "7fc1956c-15d0-4d2e-bd25-1427eb83e9b1",
        lcMapId: "7fc1956c-15d0-4d2e-bd25-1427eb83e9b1",
        name: "7F",
        shortName: "7F",
        yAxis: 0,
        altitude: 0,
        defaultPosition: [0, 0, 0],
        defaultTarget: [0, 0, 0],
        displayLod: [],
        topViewModel: "",
        isNotReady: true,
      },
      {
        id: "82db292d-76b6-4270-92d7-74d301edc94e",
        lcMapId: "82db292d-76b6-4270-92d7-74d301edc94e",
        name: "LSK 3F",
        shortName: "3F",
        yAxis: 0,
        altitude: 0,
        defaultPosition: [0, 0, 0],
        defaultTarget: [0, 0, 0],
        displayLod: [],
        topViewModel: "",
        isNotReady: true,
      },
      {
        id: "907061cb-1675-4000-9373-41281d3c96ab",
        lcMapId: "907061cb-1675-4000-9373-41281d3c96ab",
        name: "LSK 2F",
        shortName: "2F",
        yAxis: 0,
        altitude: 0,
        defaultPosition: [0, 0, 0],
        defaultTarget: [0, 0, 0],
        displayLod: [],
        topViewModel: "",
        isNotReady: true,
      },
      {
        id: "9a9e22e8-6739-42b0-8986-78c0c859674a",
        lcMapId: "9a9e22e8-6739-42b0-8986-78c0c859674a",
        name: "6F",
        shortName: "6F",
        yAxis: 0,
        altitude: 0,
        defaultPosition: [0, 0, 0],
        defaultTarget: [0, 0, 0],
        displayLod: [],
        topViewModel: "",
        isNotReady: true,
      },
      {
        id: "a6219c6b-d268-46de-8ec9-d46e795cbfc2",
        lcMapId: "a6219c6b-d268-46de-8ec9-d46e795cbfc2",
        name: "CYT 4F",
        shortName: "4F",
        yAxis: 0,
        altitude: 0,
        defaultPosition: [0, 0, 0],
        defaultTarget: [0, 0, 0],
        displayLod: [],
        topViewModel: "",
        isNotReady: true,
      },
      {
        id: "a7cef609-9914-4152-a165-6dc552476e63",
        lcMapId: "a7cef609-9914-4152-a165-6dc552476e63",
        name: "CYT UG",
        shortName: "UG",
        yAxis: 0,
        altitude: 0,
        defaultPosition: [0, 0, 0],
        defaultTarget: [0, 0, 0],
        displayLod: [],
        topViewModel: "",
        isNotReady: true,
      },
      {
        id: "a82f3739-1b26-4e38-9455-a3075e4e55ac",
        lcMapId: "a82f3739-1b26-4e38-9455-a3075e4e55ac",
        name: "Room2539",
        shortName: "Rm2539",
        yAxis: 0,
        altitude: 1,
        defaultPosition: [-1, 1, 0],
        defaultTarget: [0, 1, -2.5],
        topViewModel: "mesh_alignment/rm2539/top_view/rm2539_top_view_v1.glb",
        meshGround:
          "mesh_alignment/rm2539/mesh_ground/rm2539_mesh_ground_v1.glb",
        lod: "mesh_alignment/rm2539/splat/rm2539_v1_100_20_1_c512_x16_h0_st_3_3_0/lod-meta.json",
        displayLod: ["a82f3739-1b26-4e38-9455-a3075e4e55ac"],
      },
      {
        id: "aca2686d-d34a-45bc-8735-a1cdf98fd925",
        lcMapId: "aca2686d-d34a-45bc-8735-a1cdf98fd925",
        name: "CYT 5F",
        shortName: "5F",
        yAxis: 0,
        altitude: 0,
        defaultPosition: [0, 0, 0],
        defaultTarget: [0, 0, 0],
        displayLod: [],
        topViewModel: "",
        isNotReady: true,
      },
      {
        id: "bb94db39-9f6a-4b2b-becb-3982f456ef65",
        lcMapId: "bb94db39-9f6a-4b2b-becb-3982f456ef65",
        name: "CYT 6F",
        shortName: "6F",
        yAxis: 0,
        altitude: 0,
        defaultPosition: [0, 0, 0],
        defaultTarget: [0, 0, 0],
        displayLod: [],
        topViewModel: "",
        isNotReady: true,
      },
      {
        id: "bbbf6b6c-232a-41a7-9a64-4be0ce01c9cd",
        lcMapId: "bbbf6b6c-232a-41a7-9a64-4be0ce01c9cd",
        name: "LG5",
        shortName: "LG5",
        yAxis: 0,
        altitude: 0,
        defaultPosition: [0, 0, 0],
        defaultTarget: [0, 0, 0],
        displayLod: [],
        topViewModel: "",
        isNotReady: true,
      },
      {
        id: "be73849d-994a-4e4f-8f4c-961bcfdcb45e",
        lcMapId: "be73849d-994a-4e4f-8f4c-961bcfdcb45e",
        name: "LSK 7F",
        shortName: "7F",
        yAxis: 0,
        altitude: 0,
        defaultPosition: [0, 0, 0],
        defaultTarget: [0, 0, 0],
        displayLod: [],
        topViewModel: "",
        isNotReady: true,
      },
      {
        id: "c9766a04-e0dd-4ce8-a312-9c14bba51228",
        lcMapId: "c9766a04-e0dd-4ce8-a312-9c14bba51228",
        name: "LSK 1F",
        shortName: "1F",
        yAxis: 0,
        altitude: 0,
        defaultPosition: [0, 0, 0],
        defaultTarget: [0, 0, 0],
        displayLod: [],
        topViewModel: "",
        isNotReady: true,
      },
      {
        id: "ce647405-f860-4e27-a678-bb783dc610a7",
        lcMapId: "ce647405-f860-4e27-a678-bb783dc610a7",
        name: "CYT 2F",
        shortName: "2F",
        yAxis: 0,
        altitude: 0,
        defaultPosition: [0, 0, 0],
        defaultTarget: [0, 0, 0],
        displayLod: [],
        topViewModel: "",
        isNotReady: true,
      },
      {
        id: "ecaf7407-0dd6-4602-8d39-0f5e8c50cd16",
        lcMapId: "ecaf7407-0dd6-4602-8d39-0f5e8c50cd16",
        name: "4F",
        shortName: "4F",
        yAxis: 0,
        altitude: 0,
        defaultPosition: [0, 0, 0],
        defaultTarget: [0, 0, 0],
        displayLod: [],
        topViewModel: "",
        isNotReady: true,
      },
      {
        id: "f75d121e-466f-4500-91a6-f3a99f6f4258",
        lcMapId: "f75d121e-466f-4500-91a6-f3a99f6f4258",
        name: "LSK 6F",
        shortName: "6F",
        yAxis: 0,
        altitude: 0,
        defaultPosition: [0, 0, 0],
        defaultTarget: [0, 0, 0],
        displayLod: [],
        topViewModel: "",
        isNotReady: true,
      },
      {
        id: "f8a4716b-abcb-4e22-9d0d-660c6451128d",
        lcMapId: "f8a4716b-abcb-4e22-9d0d-660c6451128d",
        name: "5F",
        shortName: "5F",
        yAxis: 0,
        altitude: 0,
        defaultPosition: [0, 0, 0],
        defaultTarget: [0, 0, 0],
        displayLod: [],
        topViewModel: "",
        isNotReady: true,
      },
    ],
  },
};
